import Cookie from 'js-cookie'
import __snakeCase from 'lodash/snakeCase'
import moment from 'moment'

import type { Locale } from '@libs/typescript-utils'
import {
  APP_NAME,
  DEFAULT_COOKIE_EXPIRATION_DAYS,
  DEFAULT_LANGUAGE,
  getCommonDefaultLanguage,
  setCommonDefaultLanguage,
  setCommonLanguage,
} from '@libs/typescript-utils'

import { ROWS_PER_PAGE_OPTIONS } from '../constants'
import { formatDate } from './date'

export const DATE_FILTER_COOKIE_NAME_PREFIX = 'quick_filter_'
export const PAGE_SIZE_COOKIE_NAME = 'quick_default_page_size'

const COOKIE_EXPIRATION_DAYS = DEFAULT_COOKIE_EXPIRATION_DAYS

// COOKIE based
export function getDefaultLanguage(defaultLang = DEFAULT_LANGUAGE): Locale {
  return getCommonDefaultLanguage(APP_NAME.TMS, defaultLang)
}
// only set language cookie when not exists
export function setDefaultLanguage(defaultLang: Locale) {
  setCommonDefaultLanguage(APP_NAME.TMS, defaultLang, COOKIE_EXPIRATION_DAYS)
}
// always change language cookie
export function changeLanguage(lang: Locale) {
  moment.locale(lang)
  setCommonLanguage(APP_NAME.TMS, lang, COOKIE_EXPIRATION_DAYS)
}

function getFilterCookieName(name: string) {
  return `${DATE_FILTER_COOKIE_NAME_PREFIX}${__snakeCase(name)}`
}

export function getDateFilter(name: string) {
  const cookieName = getFilterCookieName(name)
  const date = Cookie.get(cookieName)
  return date ? formatDate(date) : null
}

export function setDateFilter(name: string, value: string) {
  const cookieName = getFilterCookieName(name)
  Cookie.set(cookieName, value, {
    expires: COOKIE_EXPIRATION_DAYS,
  })
}

export function getCookie(name: string) {
  return Cookie.get(__snakeCase(name))
}

export function setCookie(name: string, value: number | string, expDateOrDays: Date | number) {
  Cookie.set(__snakeCase(name), String(value), { expires: expDateOrDays })
}

// dashboard table list rows-per-page-options
export function getDefaultPageSize() {
  const num = Cookie.get(PAGE_SIZE_COOKIE_NAME)

  if (import.meta.env.VITE_ROWS_PER_PAGE) {
    return Number(import.meta.env.VITE_ROWS_PER_PAGE)
  }

  if (num) {
    return Number(num)
  }

  return ROWS_PER_PAGE_OPTIONS[0]
}

export function setDefaultPageSize(value: number | string) {
  Cookie.set(PAGE_SIZE_COOKIE_NAME, String(value), {
    expires: COOKIE_EXPIRATION_DAYS,
  })
}
